import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
import { OFFER_ANCHOR } from './constants';
const START_SECONDS = 15 * 60;
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function UrgencyBanner() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  return;
}